<template>
  <div class="liveness-page msg-page" v-if="isShow">
    <div class="msg-hd">
      <div v-if="msg.png" class="msg-png" style="height: auto;display:flex;justify-content:center;">
        <img :src="msg.png" alt="" style="width:120px;height:120px;">
      </div>
      <van-icon v-else :class="msg.status" size="120" :name="msg.icon" :color="msg.icon_color"/>
    </div>
    <div class="msg-bd">
      <div class="title">{{msg.title}}</div>
      <div class="desc" style="text-indent:25px;word-break: break-all;" v-html="msg.desc"></div>
    </div>
    <div class="btn">
      <!-- 注册 -->
      <van-button v-if="userData.is_check != 1 && !faceResult && switch1" type="info" round block plain :disabled="ocrDisabled" @click="toIndex" color="#0AA8AF">
        {{btnText1}}</van-button>
      <van-button v-if="userData.is_check != 1 && !faceResult  && switch2" type="info" round block :disabled="ocrDisabled" @click="toOcr" color="#0AA8AF">
        {{btnText2}}</van-button>

      <van-button v-for="(item, index) in msgButtons" :key="index" :type="item.type" round block @click="item.onClick" color="#0AA8AF">
        {{item.txt}}</van-button>

      <!-- 患者领药/预测单解锁 (前面两个按钮存在的话这两个按钮就不会显示) -->
      <van-button v-if="showBtn1&&!(userData.is_check != 1 && !faceResult && switch1)" type="info" round block plain :disabled="ocrDisabled" @click="toIndex" color="#0AA8AF">
        {{btnText1}}</van-button>
      <van-button v-if="showBtn2&&!(userData.is_check != 1 && !faceResult  && switch2)" type="info" round block :disabled="ocrDisabled" @click="toOcr" color="#0AA8AF">
        {{btnText2}}</van-button>

    </div>

    <van-popup class="liveness-popup" v-model="showImage" closeable close-icon-position="top-left" >
      <div class="liveness-box">
        <div class="liveness-text">
          <img :src="image" alt="">
        </div>
        <div class="btns">
          <van-button type="info" plain round @click="showImage = false" color="#0AA8AF">放弃上传</van-button>
          <van-button type="info" round :disabled="submitBtnDisabled"  @click="submit" color="#0AA8AF">确认上传</van-button>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
  import msgupload from "@/assets/msg_upload.png";
  import {
    checkin,
    checkFace,
    LiveNess,
    patientFaceApply,
    jumpOverFace,
    GetPatient
  } from "../../api/api";
      import { DownloadImage } from '@/api/patient'
  import {
    mapState
  } from "vuex";
  import Vue from "vue";
  import {
    Toast,
    Dialog,
  } from "vant";
import { isPCWechat } from '@/utils/utils';
  Vue.use(Toast);
  Vue.use(Dialog);

  let hostname = window.location.hostname
  hostname = hostname.substring(hostname.indexOf('.'))
  let baseUrl = window.location.protocol + '//api' + hostname;

  export default {
    data() {
      return {
        userData: {},
        msgupload: msgupload,
        showImage: false,
        msg: {
          status: 'warn', // success;warn;info;error
          icon: '', // vant-ui Icon name
          png: '/static/checkIdentify.jpg',
          title: '用户信息验证',
          desc: '采集人脸识别信息之前需要得到您的授权，是否同意人脸识别？'
        },
        msgButtons: [
          // {
          //   txt: '拍照上传',
          //   type: 'info',
          //   onClick: this.chooseImage.bind(this)
          // }
        ],
        btnText1:'不同意并返回',
        btnText2:'同意并继续',
        switch1:true,
        switch2:true,
        icon_color:'',
        image: '',
        ocrUrl: '',
        faceResult: null,
        type: '患者申请', // 识别类型
        predict_id: '', // 预测单ID
        isShow: false,
        ocrDisabled: false,
        submitBtnDisabled: false,

        showBtn1:false,
        showBtn2:false,
        recognition_num:0,
        is_recognition:0,
      }
    },
    computed: {
      ...mapState(['patientInfo','patientOne']),
    },
    async created() {
      if(this.$route.query.category) this.type= this.$route.query.category;
      if(this.$route.query.predict_id) this.predict_id= this.$route.query.predict_id;

      let { data } = await checkin();
      this.userData = data
      let patientRes= await GetPatient({papid: this.userData.papid})
        const {
          patient,
          phase,
          predict,
          family,
          frontStatus,
          hospital,
          doctor,
          drugstore,
          mode_name,
          need_face_ocr,
        } = patientRes.data;
      if(predict) {
        this.recognition_num=predict.recognition_num
        this.is_recognition=predict.is_recognition
      }
      await this.check()
    },
    methods: {
      check() {
        let sendData={}
        if(this.type=="患者申请"){//患者注册
          sendData={ type: this.type}
          if (this.userData.is_check == 1) {
            this.msg.title = '人脸识别成功'
            this.msg.status = 'success'
            this.msg.png = ''
            this.msg.icon = 'checked'
            // this.msg.desc = '人脸识别成功，请继续上传入组材料。'
            let text='阅读并签署知情同意书'
            this.msg.desc = '请您根据提示进入下一步阅读并签署知情同意书。'

            this.msg.icon_color='#0AA8AF'
            this.switch1=false;
            this.switch2=false;
            this.msgButtons = [{
              txt: text,
              type: 'info',
              onClick: this.toBlank.bind(this)
            }]
            this.isShow = true
            return
          }
        }

        if(this.type=="患者领药"){
          sendData={ type: this.type,predict_id:this.predict_id}
          if (this.is_recognition==1) {
            this.msg.title = '人脸识别成功'
            this.msg.status = 'success'
            this.msg.png = ''
            this.msg.icon = 'checked'
            // this.msg.desc = '人脸识别成功，请继续上传入组材料。'
            let text='下一步'
            this.msg.desc = `人脸识别成功，请携带相关资料及时去药房领药。`

            this.msg.icon_color='#0AA8AF'
            this.switch1=false;
            this.switch2=false;
            this.msgButtons = [{
              txt: text,
              type: 'info',
              onClick: this.toBlank.bind(this)
            }]
            this.isShow = true
            return
          }else{
            this.showBtn1=true;
            this.showBtn2=true;
          }
        }

        if(this.type=="预测单解锁"){
          sendData={ type: this.type,predict_id:this.predict_id}
          if (this.is_recognition==1) {
            this.msg.title = '人脸识别成功'
            this.msg.status = 'success'
            this.msg.png = ''
            this.msg.icon = 'checked'
            // this.msg.desc = '人脸识别成功，请继续上传入组材料。'
            let text='下一步'
            this.msg.desc = `人脸识别成功，请携带相关资料及时去药房领药。`

            this.msg.icon_color='#0AA8AF'
            this.switch1=false;
            this.switch2=false;
            this.msgButtons = [{
              txt: text,
              type: 'info',
              onClick: this.toBlank.bind(this)
            }]
            this.isShow = true
            return
          }else{
            this.showBtn1=true;
            this.showBtn2=true;
          }
        }
        checkFace(sendData).then(res => {
          if (res.data) {
            this.showBtn1=false;
            this.showBtn2=false;
            this.faceResult = res.data.face
            if (this.faceResult.status == '等待审核') {
              this.msg.title = '已上传照片'
              this.msg.status = 'success'
              this.msg.png = ''
              this.msg.icon = 'checked'
              this.msg.icon_color='#0AA8AF'
              if(this.type=="患者领药") this.msg.desc = '温馨提示：人脸照片上传成功后，请联系项目办处理，联系电话010-56592455。'
              if(this.type=="患者申请") this.msg.desc = '已上传照片，请等待项目办进行审核。项目办将在10个工作日内审核完成。如需加急请联系项目办：010-56592455。'
              if(this.type=="预测单解锁") this.msg.desc = '已上传照片，请等待项目办进行审核。项目办将在10个工作日内审核完成。如需加急请联系项目办：010-56592455。'
              
              this.msgButtons = [{
                txt: '下一步',
                type: 'info',
                onClick: this.toIndex.bind(this)
              }]
            } else if (this.faceResult.status == '审核通过') {
              this.msg.title = '人脸识别成功'
              this.msg.status = 'success'
              this.msg.png = ''
              this.msg.icon = 'checked'
              this.msg.icon_color='#0AA8AF'
              if(this.type=="患者领药"){
                 this.msg.desc = `人脸识别成功，请携带相关资料及时去药房领药。`
                 this.msgButtons = [{
                  txt: '下一步',
                  type: 'info',
                  onClick: this.toBlank.bind(this)
                }]
              }
              if(this.type=="患者申请"){
                 this.msg.desc = '请您根据提示进入下一步阅读并签署知情同意书。'
                 this.msgButtons = [{
                  txt: '阅读并签署知情同意书',
                  type: 'info',
                  onClick: this.toBlank.bind(this)
                }]
              }
              if(this.type=="预测单解锁"){
                 this.msg.desc = `人脸识别成功，请携带相关资料及时去药房领药。`
                 this.msgButtons = [{
                  txt: '下一步',
                  type: 'info',
                  onClick: this.toBlank.bind(this)
                }]
              }
              
            } else if (!this.faceResult || this.faceResult.status == '审核未通过') {
              let reason = ''
              if (this.faceResult.logs.length > 0 && this.faceResult.logs[0].reason) {
                // let text=this.faceResult.logs[0].reason.replace(/\n/g,"<br/>")
                // reason = `<div class="fail-reason-container">
                //             <div class="word-break fail-reason">驳回原因：</div>
                //             <span class="word-break fail-reason">${text}</span>
                //           </div>`
                reason =`您的人脸照片审核未通过，原因为："`+this.faceResult.logs[0].reason+`"，请您重新拍摄人脸照片`
                console.log(reason)
              }
              this.msg.title = '人脸照片被驳回'
              this.msg.status = 'error'
              this.msg.png = ''
              this.msg.icon = 'warning'
              this.msg.desc = `${reason?reason:''}`
              this.msgButtons.push(
                {
                  txt: '重新上传照片',
                  type: 'info',
                  onClick: this.chooseImage.bind(this)
                }
              )
            }
          } else {
            if(this.type=="患者领药"){
              console.log("人脸识别次数",this.recognition_num)
              if(localStorage.getItem("alreadyTwice")=='1') this.recognition_num=2
              if (this.recognition_num == 1) {
                this.fail_onece()
                this.msg.desc= `当前人脸识别失败，请您重新进行识别。<br/><br/><div style="text-indent:25px;">温馨提示：请切换到前置摄像头，拍摄时请保持五官无遮挡，光线充足。如有问题请联系项目办：010-56592455。</div>`
                this.showBtn1=false;
                // this.showBtn2=false;
              }else if(this.recognition_num >= 2){
                this.fail_twice()
                this.msg.desc = `您已人脸识别失败两次，请您拍照上传。<br/><br/><div style="text-indent:25px;">温馨提示：人脸照片上传成功后，请联系项目办处理，联系电话：010-56592455。</div>`
                this.showBtn1=false;
                this.showBtn2=false;
              }
              if (this.recognition_num < 2) {
                this.msgButtons = []
              } else {
                this.msgButtons.push(
                  {
                    txt: '前往拍照上传',
                    type: 'info',
                    onClick: this.chooseImage.bind(this)
                  }
                )
              }
            }else if(this.type=="患者申请"||this.type=="预测单解锁"){
              if (this.userData.check_total == 1) {
                this.fail_onece()
              }else if(this.userData.check_total >= 2){
                this.fail_twice()
              }
              if (this.userData.check_total < 2) {
                this.msgButtons = []
              } else {
                this.msgButtons.push(
                  {
                    txt: '前往拍照上传',
                    type: 'info',
                    onClick: this.chooseImage.bind(this)
                  }
                )
              }
            }
          }
          this.isShow = true
        }).catch(err => {
          Toast(err.response.data.message);
        });
        console.log("msgButtons",this.msgButtons)
        console.log("faceResult",this.faceResult)
        console.log("按钮:",this.userData.is_check != 1 && !this.faceResult && this.switch1,
                            this.userData.is_check != 1 && !this.faceResult  && this.switch2,
                            this.showBtn1&&!(this.userData.is_check != 1 && !this.faceResult && this.switch1),
                            this.showBtn2&&!(this.userData.is_check != 1 && !this.faceResult  && this.switch2))
      },
      fail_onece(){
        this.msg.title = '人脸识别失败'
        this.msg.status = 'error'
        this.msg.png = ''
        this.msg.icon = 'warning'
        this.msg.desc = `当前人脸识别失败，请您重新进行识别。<br/><br/><div style="text-indent:25px;">注意：请切换到前置摄像头，拍摄时请保持光线充足；两次识别失败后，将拍照上传至后台人工审核。如有问题请联系项目办：010-56592455。</div>`
        this.btnText2="再次人脸识别";
        this.switch1=false;
        this.switch2=true;
      },
      fail_twice(){
        this.msg.title = '人脸识别失败'
        this.msg.status = 'error'
        this.msg.png = ''
        this.msg.icon = 'warning'
        this.msg.desc = `您已人脸识别失败两次，请您拍照上传。<br/><br/><div style="text-indent:25px;">注意：人脸照片上传成功后，项目办将在10个工作日内审核完成。如需加急请联系项目办：010-56592455。</div>`
        this.switch1=false;
        this.switch2=false;
        this.showBtn1=false;
        this.showBtn2=false;
      },
      toOcr() {
        // let redirectUrl = window.location.protocol + '//' + window.location.hostname + '/apply/liveness'
        // this.ocrDisabled = true
        // let reqData = {redirectUrl: redirectUrl}
        // let reqData = {}
        // if(this.type=="患者领药") {
        //   // redirectUrl=window.location.protocol +'//'+window.location.hostname+'/apply/liveness'+'?category='+this.type+'&predict_id='+this.predict_id ,
        //   // console.log("患者领药-redirectUrl",redirectUrl)
        //   reqData = { 
        //     predict_id:this.predict_id,
        //     type:this.type
        //   }
        // }
        // if(this.type=="预测单解锁") {
        //   // redirectUrl = `${window.location.protocol}//${window.location.hostname}/apply/liveness?id=${this.predict_id}`
        //   reqData = { 
        //     predict_id:this.predict_id,
        //     type:this.type
        //   }
        // }
        const reqData = { 
            predict_id:this.predict_id,
            type:this.type
          }
        this.$router.push({name:"RecordVideo",query:{...reqData}})
        return false;
        // LiveNess(reqData).then((res) => {
        //   if (res.data.result == 'success') {
        //     if (res.data.url) {
        //       this.ocrUrl = res.data.url
        //       window.location.href = this.ocrUrl
        //     }
        //     if (res.data.message) {
        //       Toast(res.data.message)
        //     }
        //     this.ocrDisabled = false
        //   } else if (res.data.result == 'fail') {
        //     this.ocrDisabled = false
        //     if (res.data.message) {
        //       Toast(res.data.message)
        //     }
        //   } else if (res.data.result == 'report') {
        //     this.ocrDisabled = false
        //     Toast("请拍照上传");
        //     Dialog.alert({
        //       title: '提示',
        //       message: '人脸识别已达两次，请拍照上传。',
        //     }).then(() => {
        //       localStorage.setItem("alreadyTwice",'1')
        //       this.$router.go(0)
        //     })
        //   }
        // }).catch((err) => {
        //   this.ocrDisabled = false
        //   // Toast(err.response.data.message);
        //   console.log(err)
        // })
      },
      toIndex() {
        this.$router.replace({
          name: "Timeline",
        });
      },
      toBlank() {
        this.$router.replace({
          name: "Blank",
        });
      },
      submit() {
        if (!this.image) {
          Toast("请上传图片");
          return false;
        }
        this.submitBtnDisabled = true
        let sendData={
          papid: this.userData.papid,
          image: this.image,
          type: this.type
          }
        if(this.type=="患者领药"||this.type=="预测单解锁") sendData={
          papid: this.userData.papid,
          image: this.image,
          type: this.type,
          predict_id:this.predict_id
        }
        patientFaceApply(sendData)
          .then(res => {
            this.$router.replace({
              name: "Blank"
            });
            this.submitBtnDisabled = false;
            this.showImage = false;
            Toast.clear();
          })
          .catch(err => {
            this.submitBtnDisabled = false;
            this.showImage = false;
            Toast.clear();
            Toast(err.response.data.message);
          });
      },
      chooseImage() {
        // this.showImage = true
        // this.image = 'http://api.papwxtest.ilvzhou.com/upload/jjga/202106/04/3199bc3b7989d67042976b49e0b9f290.jpg';
        if (isPCWechat()) {
          console.log('请使用手机端微信进行拍照上传')
          Toast("请使用手机端微信进行拍照上传");
          return false;
        }
        this.wx.chooseImage({
          count: 1,
          sizeType: ["compressed"], // 可以指定是原图还是压缩图，默认二者都有
          sourceType: ["camera"], // ["album", "camera"]可以指定来源是相册还是相机，默认二者都有
          success: async res => {
            try {
              const serverId = res.localIds[0];
              await this.uploadImage(serverId);
            } catch (err) {
              Toast(err.response.data.message);
            }
          },
          fail: function () {
            Toast("选图失败");
          }
        });
      },
      uploadImage(serverId) {
        return new Promise((resolve, reject) => {
          this.wx.uploadImage({
            localId: serverId,
            isShowProgressTips: 1,
            success: res => {
              var serverId = res.serverId; // 返回图片的服务器端ID
              Toast.loading({
                duration: 0, // 持续展示 toast
                forbidClick: true
              });
              DownloadImage({
                  params: {
                    serverId: serverId,
                  }
                })
                .then(res => {
                  this.image = this.checkImg(res.data)
                  this.showImage = true
                  Toast.clear();
                  resolve();
                })
                .catch(err => {
                  Toast.clear();
                  reject(err.response.data.message);
                });
            },
            fail: function () {
              Toast("图片上传失败");
            }
          });
        });
      },
    checkImg(img) {
      var url = img;
      if(img.indexOf('http') == -1) {
        url = this.baseUrl + img
      }
      return url 
    },
    },
    beforeDestroy(){
      localStorage.removeItem("alreadyTwice")
      console.log("人脸识别销毁")
    }

  }
</script>

<style lang="less">
  .liveness-page {
    .liveness-popup {
      height: 60%; width: calc(100% - 30px); box-sizing: border-box; overflow: hidden;
    }
    .liveness-box {
      position: relative; height:100%; display: flex; flex-direction: column;
      .liveness-title {
        background: #fff; box-sizing: content-box; width: auto;
        line-height: 24px; height: 24px; font-size: 1.6rem; text-align: center; padding: 20px 50px 10px; background: #fff; position: relative; z-index: 10;
      }
      .liveness-text {
        flex: 1; height: 50%;
        font-size: 1.4rem;
        text-align: justify;
        text-align-last: left;
        line-height: 1.5;
        height: 100%;
        padding: 15px;
        overflow-y: auto;
        transition: transform .3s;
        -webkit-overflow-scrolling: touch;
        position: relative; z-index: 0;
        img {
          width: 100%; height: 100%; margin: auto; display: block; object-fit: contain;
        }
      }
      .btns{
        width: auto;
        display: flex;
        justify-content:space-around;
        margin-bottom: 20px;
      }
    }

    .btn{
      position: fixed;
      bottom: 0;
      padding: 15px 0;
      display:flex;
      background: #fff;
      .van-button{
        margin: 0 10px;
      }
    }
    .word-break{
      word-break: break-all;
    }
    .van-popup{
      border-radius: 6px;
    }
    .van-overlay {
      background-color: fade(#000, 60%);
    }
    .fail-reason-container{
      display: flex;
      .fail-reason{
        color:red;text-indent:0;
      }
    }

  }
</style>